<template>
    <div v-if="getModalCredentialsRenew.show"
         :class="['ap2-modal ap2-modal-xs ap2-modal-content-center ap2-modal-two-options', getModalCredentialsRenew.show ? 'open': null]"
         id="confirmation-modal">
        <div class="modal-wrapper ">
            <div class="ap2-modal-header">
                <div class="modal-header-title-wrapper">
                    <div class="modal-header-reference">
                        {{ getModalCredentialsRenew.origin }} credential
                    </div>
                    <div class="modal-header-title text-capitalize">
                        {{ getModalCredentialsRenew.action }}
                    </div>
                </div>

                <div class="modal-header-close close-modal-demo">
                    <svg @click="close()"
                         height="1em"
                         viewBox="0 0 384 512"
                         xmlns="http://www.w3.org/2000/svg">
                        <path class="svg-fill"
                              d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                    </svg>
                </div>
            </div>
            <div class="ap2-modal-content" id="modal-confirmation">
                <div class="section-header-fields">
                    <div class="form-group ap2-form-group mb-2">
                        <label class="ap2-form-label mb-1"> {{ getModalCredentialsRenew.origin}} user email </label>
                        <input
                            @input="userEmail = $event.target.value"
                            class="form-control ap2-form-control"
                        />
                    </div>
                    <div class="form-group ap2-form-group mb-2">
                        <label class="ap2-form-label mb-1"> {{ getModalCredentialsRenew.origin}} user password </label>
                        <input
                            @input="userPassword = $event.target.value"
                            type="password"
                            class="form-control ap2-form-control"
                        />
                    </div>
                </div>
            </div>
            <div class="ap2-modal-footer modal-controls" style="z-index: 11;">
                <div class="modal-controls">
                    <button type="button" class="ap2-btn btn btn-dark close-modal-demo"
                            @click="close()">
                        Cancel
                    </button>
                    <button type="button" class="ap2-btn btn btn-primary close-modal-demo"
                            @click="renew()">
                        Renew
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import _ from "lodash";
import danger from "@/assets/images/triangle-exclamation-solid.svg"
import {getProblematicDataSharesEnabling} from "@/services/data-share";
import {getCookie} from "@/helpers/get-cookie";

export default {
    name: "modalCredentialsRenew",
    computed: {
        ...mapGetters(['getModalCredentialsRenew']),
        problematicDataShares() {
            return this.dataShares
        }
    },
    data() {
        return {
            userEmail: null,
            userPassword: null
        }
    },
    watch: {
        problematicDataShares: {
            handler: function (newVal) {
                this.dataSharesLoaded = true;
            }
        }
    },
    methods: {
         close() {
            this.userEmail = null;
            this.userPassword = null;
            _.set(this.getModalCredentialsRenew, 'show', false);
        },
        renew() {
            _.set(this.getModalCredentialsRenew, 'result',
                    {userEmail: this.userEmail, userPassword: this.userPassword});
            this.userEmail = null;
            this.userPassword = null;
            _.set(this.getModalCredentialsRenew, 'show', false);

        }
    }
}
</script>

<style scoped>

</style>